import { apiRoutes } from "../../config";
import { api } from "../../utils/lib/api";
import axios from "axios";
import { keyAccessToken, keyUserId } from "../../assets/js/SessionStorageNames";


export const sendCampaignCashea = (globalContext) => {
    const sendCampaign = async (enterpriseId, pricelistId, plusPercent, dateFrom, dateTo, nameCampaign, excelFile = null, pricelistName = '') => {
        try {
            globalContext.setLoaderPage(false);
            globalContext.showModalWithMsg(`Creando campaña, puede visualizar su estatus en la vista de segundo plano`);
    
            const headers = {
                "x-api-key": process.env.REACT_APP_API_KEY,
                "x-access-token": localStorage.getItem(keyAccessToken),
                "x-user-id": localStorage.getItem(keyUserId),
            };
            const url = excelFile
                ? `${process.env.REACT_APP_BACKEND_URL}/v1/cashea-campaign/send-from-excel-pricelist`
                : `${process.env.REACT_APP_BACKEND_URL}/v1/cashea-campaign/send-from-odoo-pricelist`;
            const payload = excelFile
                ? (() => {
                    const formData = new FormData();
                    formData.append('xlsx', excelFile);
                    formData.append('pricelistId', pricelistId);
                    formData.append('pricelistName', pricelistName);
                    formData.append('plusPercent', plusPercent);
                    formData.append('enterpriseId', enterpriseId);
                    formData.append('dateFrom', dateFrom);
                    formData.append('dateTo', dateTo);
                    formData.append('nameCampaign', nameCampaign);
                    return formData;
                })()
                : { pricelistId, plusPercent, enterpriseId, dateFrom, dateTo, nameCampaign };

            const res = await axios.post(url, payload, { headers });
    
            return res;
    
        } catch (err) {
            globalContext.setLoaderPage(false);
            console.error(err);
            globalContext.showModalWithMsg(
                `Ocurrió un error al crear la campaña ${err}`
            );
        }
    }
    return sendCampaign;
}

export const getListCampaignFalabella = async (
    entId,
    pageNumber = 1,
    pageItemCount = 100,
) => {
    try {
        const params = {
            pageNumber,
            pageItemCount,
        };

        return (await api.get(
            `${apiRoutes.falabella.base}/${entId}`,
            { params }
        )).data;
    } catch (error) {
        let errorMessage = "Something went wrong trying on uploadProducts";
        if (error?.response?.data) errorMessage = error?.response?.data;
    
        throw new Error(errorMessage);
    }
}

export const sendCampaignFalabella = async (
    entId, pricelistId, plusPercent = 50, dateStart, dateEnd, campaignName, excelFile = null, pricelistName = ''
) => {
    try {
        if (excelFile) {
            const formData = new FormData();
            formData.append('xlsx', excelFile);
            formData.append('pricelistId', pricelistId);
            formData.append('pricelistName', pricelistName);
            formData.append('plusPercent', plusPercent);
            formData.append('dateStart', dateStart);
            formData.append('dateEnd', dateEnd);
            formData.append('campaignName', campaignName);

            return (await axios.post(`${apiRoutes.falabella.base}/${entId}/send-from-excel-pricelist`, formData, {
                headers: {
                    "x-api-key": process.env.REACT_APP_API_KEY,
                    "x-access-token": localStorage.getItem(keyAccessToken),
                    "x-user-id": localStorage.getItem(keyUserId),
                },
            })).data;
        }

        return (await api.post(
            `${apiRoutes.falabella.base}/${entId}/send-from-odoo-pricelist`,
            { pricelistId, plusPercent, dateStart, dateEnd, campaignName }
        )).data;
    } catch (error) {
        let errorMessage = "Something went wrong trying on uploadProducts";
        if (error?.response?.data) errorMessage = error?.response?.data;
    
        throw new Error(errorMessage);
    }
}

export const deleteCampaignFalabella = async (entId, campaignId) => {
    try {
        return (await axios.delete(`${apiRoutes.falabella.base}/${entId}/${campaignId}`,
            {
                headers: {
                    "x-api-key": process.env.REACT_APP_API_KEY,
                    "x-access-token": localStorage.getItem(keyAccessToken),
                    "x-user-id": localStorage.getItem(keyUserId),
                },
            }
        )).data;
    } catch (error) {
        let errorMessage = "Something went wrong trying to delete campaign";
        if (error?.response?.data) errorMessage = error?.response?.data;
    
        throw new Error(errorMessage);
    }
}